import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';
import { IOYInputProps, IOYInputState } from './const';
import { jeact } from '../../decorators/jeact';

@jeact()
export default class OYInput extends OY<IOYInputProps, IOYInputState> {
  static displayName = 'OYInput';

  static defaultProps: Partial<IOYInputProps> = {
    maxLength: 15,
    size: "default",
    search: false,
    placeholder: '',
    radius: 0
  }

  public state: IOYInputState = {
  };

  $node = {
    input: $()
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  setNode(): void {
    this.$node = {
      input: this.$el.find(`.${styles.input}`)
    }
  }

  /**
   * 清空值
   * @exports
   */
  clear() {
    this.$node.input.val('');
  }

  protected bindInputChange() {
    this.$node.input.change((ev: Event) => {
      const value = this._setValue($(ev.target!).val());
      this.eventEmitter.emit(EEventType.onChange, value)
    })
  }

  protected bindSearch() {
    if (this.props.search) {
      this.$el.find(`.${styles.icon_search}`).click(() => {
        const value = this._setValue(this.$node.input.val());
        this.eventEmitter.emit(EEventType.onSearch, value)
      })
    }
  }

  private _setValue(value: string) {
    const { maxLength } = this.props;
    let newValue = value;
    if (maxLength) {
      newValue = value.substr(0, maxLength);
      this.$node.input.val(newValue)
    }
    return newValue;
  }
}



// WEBPACK FOOTER //
// ./src/components/OYInput/index.ts